import React, { useMemo } from 'react';
import FormInput from 'components/Input/FormInput';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

interface INameFirmwareInput {
	changeNameOfFirmware: (value: string) => void;
}

const NameFirmwareInput: React.FC<INameFirmwareInput> = ({ changeNameOfFirmware }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterFirmwareName') },
			{ max: 50, message: tForm('fieldCannotBeMoreThanCharactersLong', { count: 50 }) },
		],
		[t],
	);

	return (
		<FormInput
			testId="NameFirmwareInput"
			name="nameOfFirmware"
			label="nameLabel"
			onChange={changeNameOfFirmware}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(NameFirmwareInput);
